// extracted by mini-css-extract-plugin
export default {"ctn":"mainPoint_ctn__SXNdr","textBox":"mainPoint_textBox__2JZS6","text4":"mainPoint_text4__ZeTxR","iconItem":"mainPoint_iconItem__MFC6R","iconBox":"mainPoint_iconBox__1epaF"};